module.exports = __webpack_public_path__ + "img/珍银面膜--OK_04.bf2d13c4.jpg";